import { RequestResult } from '../../../lib/socket/model';
export const getMessagePayload = (message) => message[message.payload];
export const throwErrorOnFailedRequestReply = (message) => {
    const payload = getMessagePayload(message);
    const { result } = payload;
    if (result !== RequestResult.REQUEST_RESULT_SUCCESS) {
        throw new Error('request failed');
    }
};
export const constants = {
    pingPongInterval: 2000,
    pingPongTimeout: 6000,
};
